export enum SortingOption {
    Increase = 1,
    None = 2,
    Decrease = 3
}